import { render, staticRenderFns } from "./RailsPanel.vue?vue&type=template&id=52a6002a"
import script from "./RailsPanel.vue?vue&type=script&lang=js"
export * from "./RailsPanel.vue?vue&type=script&lang=js"
import style0 from "./RailsPanel.vue?vue&type=style&index=0&id=52a6002a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports